import { PartialStylingAttributes } from './index';
import AbstractElement from './abstractElement';
import { text as textConfig } from '@config';

export default class TextString extends AbstractElement {
  constructor (parameters) {
    super(parameters);

    this.styles = [];
    this.bb = null;
    this.stringBox = {};

    // Flags
    this.bulletLevel = 0;
    this.bulletContent = '•';
    this.bulletWidth = 0;
    this.bulletFill = null;
    this.bulletFontSize = 0;
    this.bulletStyle = 0;
    this.bulletFontFamily = null;
    this.bulletCustomFontId = null;
    this.bulletHighlight = null;
    this.bulletFontStyle = null;

    this.orderedLevel = 0;
    this.order = 1;
    this.orderedWidth = 0;
    this.orderedFill = null;
    this.orderedStart = null;
    this.orderedFontSize = 0;
    this.orderedStyle = 0;
    this.orderedNumberingStyle = 0;
    this.orderedRegex = '';
    this.orderedFontFamily = null;
    this.orderedFontWeight = null;
    this.orderedFontStyle = null;
    this.orderedHighlight = null;
    this.orderedCustomFontId = null;

    this.textContent = '';
    this.startIndex = 0;
    this.endIndex = 0;

    // Attributes
    this.x = 0;
    this.y = 0;

    this.isBlank = false;
    this.isEol = false;
    this.isNewLine = false;

    this.textAnchor = '';
    this.heading = 0;
    this.letterSpacing = 0;
    this.columnIndex = 0;
    this.line_margin = 0;
    this.paragraph_spacing = 0;
    this.first_line_margin = 0;
    this.right_margin = 0;
    this.line_spacing = 0;

    this.isButtonTriggered = false;

    this.setValues(parameters);
  }

  setDOM (dom) {
    const that = this;
    if (!dom) return null;

    this.dom = dom;

    const cls = dom.getAttribute('class');
    const heading = dom.dataset.heading || 0;
    const isBlank = !!cls && cls.indexOf('blank') > -1;

    let textAnchor = dom.getAttribute('text-anchor') || '';
    if (textAnchor === 'justify') textAnchor = 'justify_start';

    this.setValues($.extend(
      {
        isBlank,
        isEol: !!cls && cls.indexOf('eol') > -1,
        bb: dom.getBBox(),
        x: parseFloat(dom.getAttribute('x')),
        y: parseFloat(dom.getAttribute('y')),
        letterSpacing: null,
        heading,
        textAnchor
      }
    ));

    function parse (dom) {
      // Backward compatibility
      const bulletLevel = dom.dataset.bullet ? Number(dom.dataset.bullet) : dom.querySelector('.bullets') && !isBlank ? 1 : 0;
      const orderedLevel = dom.dataset.ordered ? Number(dom.dataset.ordered) : dom.querySelector('.ordered') && !isBlank ? 1 : 0;

      const bulletStyle = dom.dataset.bulletStyle ? Number(dom.dataset.bulletStyle) : dom.querySelector('.bullets') ? 1 : 0;
      const orderedStyle = dom.dataset.orderedStyle ? Number(dom.dataset.orderedStyle) : dom.querySelector('.ordered') ? 6 : 0;
      const orderedStart = dom.dataset.orderedStart ? Number(dom.dataset.orderedStart) : null;
      const orderedNumberingStyle = Number(dom.dataset.orderedNumberingStyle) || 0;
      const orderedRegex = dom.dataset.orderedRegex || '';

      $(dom).contents().each(function () {
        if (this.nodeType === 1) {
          const span = new INKIVE.Text.Span().setDOM(this);
          if (!span.isBullet() && !span.isOrdered()) {
            if (span.hasSubelements()) {
              parse(span.dom);
            } else {
              that.textContent += span.textContent;

              for (let i = 0; i < PartialStylingAttributes.length; i++) {
                const att = PartialStylingAttributes[i];
                let val = span[att.replace(/-/g, '_')];
                if (val) {
                  val = val.toString();
                }

                const isXWithBullets = att === 'x' && (that.bulletLevel || that.orderedLevel);

                if (val && !isXWithBullets) {
                  that.styles.push({
                    start: that.startIndex + that.textContent.length - span.textContent.length,
                    end: that.startIndex + that.textContent.length,
                    attribute: att,
                    value: span[att.replace(/-/g, '_')]
                  });
                }
              }
            }
          }

          if (!that.bulletLevel) {
            that.bulletLevel = bulletLevel;
            that.bulletStyle = bulletStyle;
            if (span.isBullet()) {
              const bulletDetails = span.getBulletDetails();
              that.bulletWidth = span.bulletWidth;
              that.bulletFill = span.bulletFill;
              that.bulletFontSize = span.bulletFontSize;
              that.bulletFontFamily = span.font_family;
              that.bulletCustomFontId = span.custom_font_id;
              that.customBulletSymbol = bulletDetails.customBulletSymbol;
              that.bulletFontStyle = span.font_style;
              that.bulletHighlight = span.highlight;
            }
          }
          if (!that.orderedLevel) {
            that.orderedLevel = orderedLevel;
            that.orderedStyle = orderedStyle;
            that.orderedStart = orderedStart;
            that.orderedNumberingStyle = orderedNumberingStyle;
            that.orderedRegex = orderedRegex;
            if (span.isOrdered()) {
              const orderDetails = span.getOrderDetails();
              // This line is to solve backward compatibility issues with ordered mark
              // Old document does not have ordered regex, if it has ordered mark, we convert it to ordered regex
              that.orderedRegex = that.orderedStyle <= 10
                ? that.orderedRegex || textConfig.orderedList.markMapping[orderDetails.mark] || ''
                : that.orderedRegex || '';

              that.orderedWidth = span.orderedWidth;
              that.orderedFill = span.orderedFill;
              that.orderedFontSize = span.orderedFontSize;
              that.orderedFontFamily = span.font_family;
              that.orderedFontWeight = span.font_weight;
              that.orderedFontStyle = span.font_style;
              that.orderedHighlight = span.highlight;
              that.orderedCustomFontId = span.custom_font_id;
            }
          }
        } else if (this.nodeType === 3) {
          that.textContent += this.nodeValue;
        }
      });
    }

    parse(this.dom);

    return this;
  }

  getChars (startFrom, line, parentFontSize, parentStyle) {
    let characterBBoxes = [];
    startFrom = startFrom || 0;
    line = line || 0;
    let isRightToLeft = false;
    let lineFontSize = 0;

    if (this.dom) {
      let orderDelta = 0;
      if (this.orderedLevel) {
        orderDelta = (this.order === -1) ? 1 : this.dom.querySelector('.ordered')?.textContent?.length;
      }

      const textLen = this.textContent.length;
      const dx = this.dom.getAttribute('dx')?.split(' ') || [];
      for (let k = 0; k < textLen; k++) {
        this.lastIndex = startFrom + k;
        lineFontSize = this.getFontSizeFromCharIndex(this.lastIndex, parentStyle);
        try {
          characterBBoxes.push($.extend(
            {
              char: this.textContent.charAt(k),
              line,
              fontSize: lineFontSize,
              index: this.bulletLevel ? this.lastIndex + 1 : this.lastIndex + orderDelta,
              dx: parseFloat(dx[k] || 0)
            }, this.dom.getExtentOfChar(this.bulletLevel ? k + 1 : k + orderDelta)));
        } catch (e) {
          break;
        }
      }

      isRightToLeft = this.dom.parentElement && this.dom.parentElement.getAttribute('direction') === 'rtl';
    }

    const lastIndex = characterBBoxes.length - 1;
    const lastChar = characterBBoxes[lastIndex];

    if (lastChar && this.isEol && !this.isBlank) {
      this.containsFakeChar = true;
      characterBBoxes.push({
        x: lastChar.x + (isRightToLeft ? 0 : lastChar.width),
        y: lastChar.y,
        width: 0,
        fontSize: lineFontSize,
        height: lastChar.height,
        line
      });
    }

    // RTL text may contain LTR text (for example an Arabic word with a two digit number)
    if (isRightToLeft) {
      // The modified array for RTL text
      let modifiedCharacterBBoxes = [];
      // A sub array of character boxes, containing LTR elements
      // The text may have multiple instances of LTR parts
      let subarray = [];
      // The criterion to test if a character is non-RTL (spaces are treated separately)
      const isLtr = /\w/;

      // Test each character
      characterBBoxes.forEach(c => {
        // Spaces INSIDE LTR text are part of that LTR text (but at borders are RTL)
        if (c.char === '\u00A0' && subarray.length) {
          subarray.push(c);
        } else if (c.char && isLtr.test(c.char)) {
          // Store non-RTL characters for later manipulation
          subarray.push(c);
        } else {
          // A RTL character found, but first:
          // If the array of non-RTL is not empty, reverse it (to match the flow of RTL text)
          if (subarray.length) {
            // If the non-RTL characters array ends with space, that space is at border and
            // should not be treated as part of LTR text
            if (subarray.length > 1 && subarray[subarray.length - 1].char === '\u00A0') {
              // Move the last element to the beginning, so in the reversed array it will be in the right position
              subarray.unshift(subarray.pop());
            }
            subarray.length > 1 && subarray.reverse();
            // Add the reversed non-RTL characters array to the result
            modifiedCharacterBBoxes = modifiedCharacterBBoxes.concat(subarray);
            // Truncate the array for the next possible occurrence
            subarray = [];
          }

          // Store the RTL character without touching
          modifiedCharacterBBoxes.push(c);
        }
      });

      // If the sentence ends with LTR text, add those too
      if (subarray.length) {
        subarray.length > 1 && subarray.reverse();
        modifiedCharacterBBoxes = modifiedCharacterBBoxes.concat(subarray);
      }

      // If there is a fake character, make sure it's x is derived from last real character.
      // Details: if the RTL string ends with LTR element, then the last character will not have
      // the left most x (since we invert any LRT sequence to match RTL flow).
      // For example, if we try to render 1234 from right ot left, then 4 is the last character
      // entered by user, while we render 1 as the final (the left most) character. In this case
      // the fake character should be aligned to 1 (not 4).
      const L = modifiedCharacterBBoxes.length;
      if (L >= 2 && !modifiedCharacterBBoxes[L - 1].char /* undefined char means a fake one */) {
        modifiedCharacterBBoxes[L - 1].x = modifiedCharacterBBoxes[L - 2].x;
      }

      characterBBoxes = modifiedCharacterBBoxes;
    }

    return characterBBoxes;
  }

  getFontSizeFromCharIndex (index, parentStyle) {
    if (!this.dom) return 0;

    const characterFontSize = parentStyle?.find(style => style.attribute === 'font-size' && style.start <= index && style.end > index)?.value || 0;

    return characterFontSize;
  }

  getWidth () {
    const chars = this.getChars();

    return chars.length > 1
      ? chars[chars.length - 1].width + chars[chars.length - 1].x - chars[0].x
      : (chars.length === 1) ? chars[0].width : 0;
  }

  getCRect () {
    return $.extend({}, this.dom.getBoundingClientRect());
  }

  getStringStyles (allStyles) {
    const that = this;

    // ---------------------------------------------------------------------------------------------------------------
    // Find styles for the current string
    // Conditions:
    // 1.            [string.startIndex]....[start].................[end]........[string.endIndex]
    // 2. [start]    [string.startIndex]............................[end]........[string.endIndex]
    // 3.            [string.startIndex]....[start]..............................[string.endIndex]    [end]
    // 4. [start]    [string.startIndex].........................................[string.endIndex]    [end]
    //
    const lineStyles = [];
    if (allStyles && allStyles.length) {
      $.each(allStyles, function (i, style) {
        if (style.attribute === 'normal') {
          return true;
        }
        /* 1 */
        if (style.start >= that.startIndex && style.end <= that.endIndex) {
          lineStyles.push($.extend({}, style));
        } else if (style.start < that.startIndex && style.end <= that.endIndex && style.end > that.startIndex) { /* 2 */
          lineStyles.push($.extend({}, style, { start: that.startIndex }));
        } else if (style.start >= that.startIndex && style.start < that.endIndex && style.end > that.endIndex) { /* 3 */
          lineStyles.push($.extend({}, style, { end: that.endIndex }));
        } else if (style.start < that.startIndex && style.end > that.endIndex) { /* 4 */
          lineStyles.push($.extend({}, style, {
            start: that.startIndex,
            end: that.endIndex
          }));
        }
      });
    }

    // ---------------------------------------------------------------------------------------------------------------
    // Style collisions
    // For all conditions STYLE 2 has more weight than style 1:
    // 1. [S2]...[s1]....[e1]...[E2]
    // 2. [s1]...[S2]....[E2]...[e1]
    // 2. [s1]...[S2]....[e1]...[E2]
    // 3. [S2]...[s1]....[E2]...[e1]
    //
    let lineStylesDupLess = [];
    $.each(lineStyles, function (i, S2) {
      lineStylesDupLess = jQuery.grep(lineStylesDupLess, function (s1) {
        return (s1.start === S2.start &&
          s1.end === S2.end &&
          s1.attribute !== S2.attribute) ||
          !((s1.start >= S2.start &&
            s1.end <= S2.end &&
            s1.start < S2.end) ||
          /* 2 */ (s1.start <= S2.start && s1.end >= S2.end) ||
          /* 3 */ (s1.start <= S2.start && s1.end < S2.end && S2.start < s1.end) ||
          /* 4 */ (s1.start >= S2.start && s1.end > S2.end && s1.start < S2.end)
          );
      });

      lineStylesDupLess.push(S2);
    });

    lineStylesDupLess.sort(function (a, b) {
      return (a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0);
    });

    // Prepare substrings for
    // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/substring
    // Fetch by rule [...)
    const styles = [];
    let to = 0;
    let styled = false;
    $.each(lineStylesDupLess, function (i, style) {
      // leading substring
      if (!styled && style.start > that.startIndex) {
        styles.push({
          start: 0,
          end: style.start - that.startIndex
        });
      }

      // medium substring
      if (styled && style.start > to) {
        styles.push({
          start: to - that.startIndex,
          end: style.start - that.startIndex
        });
      }

      to = style.end;

      styled = true;

      // style
      styles.push({
        start: style.start - that.startIndex,
        end: style.end - that.startIndex,
        attribute: style.attribute,
        value: style.value
      });
    });

    if (styled) {
      // ending substring
      if (to - that.startIndex > 0) {
        styles.push({
          start: to - that.startIndex,
          end: that.textContent.length
        });
      }
    }

    return styles;
  }

  render (canvas, parent) {
    const that = this;

    const stringRenderer = new INKIVE.Text.StringRenderer(that, canvas, parent).initialize();
    stringRenderer.renderString();
  }
}
